// import Image from "next/image";
import styles from "../../styles/Home.module.css";
import Page from "../../components/Page";
// import { Roboto } from "next/font/google";

import { useState, useEffect } from "react";

// import {
//     query as dbQuery,
//     limit as queryLimit,
//     orderBy,
//     collection,
// } from "firebase/firestore";

import * as firestore from "firebase/firestore";

import {
    useCollectionData,
    useCollection,
} from "react-firebase-hooks/firestore";
import { firestore as db } from "../../firebase";
import UpdatesHolder from "../../components/UpdatesHolder";

interface Update {
    id: string;
    title: string;
    content: string;
    createdAt: firestore.Timestamp;
}

export default function Math150() {
    // const [notices, setNotices] = useState([]);
    const rawPage: string = window.location.pathname.split("/")[1];
    const page: string | null =
        rawPage === "math150"
            ? "calc"
            : rawPage === "math254"
            ? "lindisc"
            : "calc";

    useEffect(() => {
        document.title = "Math With Maki | " + rawPage[0].toUpperCase() + rawPage.slice(1);
    }, []);

    return (
        <>
            <head>
                <title>Math with Maki</title>
                <meta name="description" content="Math with Maki" />
                <link rel="icon" href="/favicon.ico" />
            </head>
            <Page
                href="math150"
                style={{
                    overflowY: "auto",
                }}
            >
                <h2>Announcements</h2>
                {/* <p>There are no announcements at this time.</p> */}
                <UpdatesHolder isAdmin={false} page={page} />
            </Page>
        </>
    );
}
